// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2UUom","upload":"Small_upload__3aQgD","imageWrap":"Small_imageWrap__2WiAK","removeBtn":"Small_removeBtn__1d4cK"};